/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../payments/refund';
import '../../payments/auth';
import '../../payments/common';
import '../common/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "PaymentRecoveryRequest": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "recoveryType": {
                    "type": ".squareup.esperanto.api.PaymentRecoveryRequest.RecoveryType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "recoveryEditMode": {
                    "type": ".squareup.esperanto.api.PaymentRecoveryRequest.RecoveryEditMode",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentRecordToRecover": {
                    "type": "bytes",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundReservationResultRecoveryDetails": {
                    "type": ".squareup.esperanto.api.RefundReservationResultRecoveryDetails",
                    "id": 5,
                    "rule": "optional"
                  },
                  "pushMoneyResultRecoveryDetails": {
                    "type": ".squareup.esperanto.api.PushMoneyResultRecoveryDetails",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RecoveryType": {
                    "values": {
                      "DEFAULT_RECOVERY_TYPE_DO_NOT_USE": 0,
                      "AUTH_RESULT": 1,
                      "REFUND_RESERVATION_RESULT": 2,
                      "PUSH_MONEY_RESULT": 3
                    }
                  },
                  "RecoveryEditMode": {
                    "values": {
                      "DEFAULT_EDIT_MODE_DO_NOT_USE": 0,
                      "MERGE": 1,
                      "REPLACE": 2,
                      "MUTATION": 3
                    }
                  }
                }
              },
              "RefundReservationResultRecoveryDetails": {
                "fields": {
                  "refundUuid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refundReservationAttemptResult": {
                    "type": ".squareup.esperanto.api.RefundReservationAttemptResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "gatewayDataBytes": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RefundReservationAttemptResult": {
                "fields": {
                  "basicGatewayResponseBytes": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isAutoVoid": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "isGatewayTimeout": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "refundError": {
                    "type": ".squareup.payments.refund.RefundError",
                    "id": 4,
                    "rule": "optional"
                  },
                  "authorizationCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "authorizationErrors": {
                    "type": ".squareup.payments.auth.AuthorizationError",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "wasOnlineRefundAuthAttempted": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "wasOnlineRefundAuthDeclineSuppressed": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "wasOnlineRefundDeclineValid": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "cardNetwork": {
                    "type": ".squareup.payments.common.CardNetwork",
                    "id": 10,
                    "rule": "optional"
                  },
                  "selectedAcquirer": {
                    "type": ".squareup.payments.common.AcquiringEntity",
                    "id": 11,
                    "rule": "optional"
                  }
                }
              },
              "PushMoneyResultRecoveryDetails": {
                "fields": {
                  "nextAttemptState": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "PaymentRecoveryResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.esperanto.api.PaymentRecoveryError",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PaymentRecoveryError": {
                "values": {
                  "DEFAULT_RECOVER_PAYMENT_ERROR_DO_NOT_USE": 0,
                  "PAYMENT_RECORD_NOT_FOUND": 1
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PaymentRecoveryRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PaymentRecoveryRequest?.nested?.RecoveryType && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PaymentRecoveryRequest?.nested?.RecoveryEditMode && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.RefundReservationResultRecoveryDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.RefundReservationAttemptResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PushMoneyResultRecoveryDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PaymentRecoveryResponse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PaymentRecoveryError) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PaymentRecoveryRequest @ squareup/esperanto/api/payment_recovery.proto at 13:1
 */
export const PaymentRecoveryRequest = $root.lookupType('squareup.esperanto.api.PaymentRecoveryRequest');
fixType(PaymentRecoveryRequest);
Builder.createAndAttachToType(PaymentRecoveryRequest);
/**
 * The types of recoverable payment operations.
 *
 * SOURCE RecoveryType @ squareup/esperanto/api/payment_recovery.proto at 18:3
 */
PaymentRecoveryRequest.RecoveryType = $root.lookupEnum('squareup.esperanto.api.PaymentRecoveryRequest.RecoveryType').values;
/**
 * The type of edit to be used for persisting recovery data.
 *
 * SOURCE RecoveryEditMode @ squareup/esperanto/api/payment_recovery.proto at 29:3
 */
PaymentRecoveryRequest.RecoveryEditMode = $root.lookupEnum('squareup.esperanto.api.PaymentRecoveryRequest.RecoveryEditMode').values;
/**
 * Data needed to reconstruct the mutation for the REFUND_RESERVATION_RESULT recovery type.
 *
 * SOURCE RefundReservationResultRecoveryDetails @ squareup/esperanto/api/payment_recovery.proto at 67:1
 */
export const RefundReservationResultRecoveryDetails = $root.lookupType('squareup.esperanto.api.RefundReservationResultRecoveryDetails');
fixType(RefundReservationResultRecoveryDetails);
Builder.createAndAttachToType(RefundReservationResultRecoveryDetails);
/**
 * A message containing the inputs needed for the refund reservation result mutation
 *
 * SOURCE RefundReservationAttemptResult @ squareup/esperanto/api/payment_recovery.proto at 83:1
 */
export const RefundReservationAttemptResult = $root.lookupType('squareup.esperanto.api.RefundReservationAttemptResult');
fixType(RefundReservationAttemptResult);
Builder.createAndAttachToType(RefundReservationAttemptResult);
/**
 * Data needed to reconstruct payment/lock state, for the PUSH_MONEY_RESULT recovery type.
 *
 * SOURCE PushMoneyResultRecoveryDetails @ squareup/esperanto/api/payment_recovery.proto at 113:1
 */
export const PushMoneyResultRecoveryDetails = $root.lookupType('squareup.esperanto.api.PushMoneyResultRecoveryDetails');
fixType(PushMoneyResultRecoveryDetails);
Builder.createAndAttachToType(PushMoneyResultRecoveryDetails);
/**
 * SOURCE PaymentRecoveryResponse @ squareup/esperanto/api/payment_recovery.proto at 118:1
 */
export const PaymentRecoveryResponse = $root.lookupType('squareup.esperanto.api.PaymentRecoveryResponse');
fixType(PaymentRecoveryResponse);
Builder.createAndAttachToType(PaymentRecoveryResponse);
/**
 * Error types associated with the payment recovery operation
 *
 * SOURCE PaymentRecoveryError @ squareup/esperanto/api/payment_recovery.proto at 130:1
 */
export const PaymentRecoveryError = $root.lookupEnum('squareup.esperanto.api.PaymentRecoveryError').values;